import React, { useState, useRef, useEffect } from 'react';
import styled from '../../../../consts/styled';

const INTERVAL = 500;
const SKIP_INTERVALS = 3;

export const NeverShrink = styled(({ className, children }) => {
  const [height, setHeight] = useState<number>(-1);
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const currentHeight = ref.current?.clientHeight || 0;
    if (count >= SKIP_INTERVALS && currentHeight > height) {
      setHeight(currentHeight);
    }

    const timer = setTimeout(() => {
      setCount(count + 1);
    }, INTERVAL);

    return () => clearTimeout(timer);
  }, [count, children, height]);

  return (
    <div className={className} style={{ minHeight: height, paddingBottom: '64px' }}>
      <div ref={ref}>{children}</div>
    </div>
  );
})`
  box-sizing: border-box;
  min-height: 100px;
`;

export const StyledTabs = styled.div`
  z-index: 100;
  width: 100%;
  justify-content: center;
  margin: 10px 0 50px;
  display: flex;
  position: relative;
  &:before {
    content: '';
    width: 100%;
    height: 1px;
    background-color: rgba(213, 214, 222, 0.5);
    position: absolute;
    bottom: 23px;
    left: 0;
  }
`;
